import { FormikErrors } from 'formik'

import { FieldValidationOptions } from '../api/FieldValidationOption'

export const validateField = <T>(errors: FormikErrors<T>, values: T) => {
  const setError = setErrors(errors)

  return (field: keyof T, validation: FieldValidationOptions | undefined, fieldName: string) => {
    const error = setError(field)
    const value = (values[field] || '') as string

    if (!validation) return

    if (!isValidRequired(value)) {
      return error(`${fieldName} is required`)
    }

    if (validation.regex) {
      const regex = new RegExp(validation.regex)
      if (!regex.test(value)) {
        return error(`Invalid ${fieldName}`)
      }
    }

    if (!isValidMinLength(value, validation)) {
      return error(`${fieldName} must be at least ${validation.minLength} characters long`)
    }

    if (!isValidMaxLength(value, validation)) {
      return error(`Maximum character limit is ${validation.maxLength}`)
    }
  }
}

const isValidRequired = (fieldValue: string): boolean => {
  return !!fieldValue
}

const isValidMinLength = (fieldValue: string, validation: FieldValidationOptions): boolean => {
  const minLength = validation?.minLength
  return minLength === null || minLength === undefined || fieldValue.length >= minLength
}

const isValidMaxLength = (fieldValue: string, validation: FieldValidationOptions): boolean => {
  const maxLength = validation?.maxLength
  return maxLength === null || maxLength === undefined || fieldValue.length <= maxLength
}

const setErrors = <T>(errors: FormikErrors<T>) => {
  return (field: keyof T) => (message: string) => {
    errors[field] = message as unknown as FormikErrors<T>[keyof T]
  }
}
